export default "__VITE_ASSET__CiX9KkzM__"